import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Button, Divider, Grid, Paper, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

// Redux wrappers
import TagsCard from '../../redux/containers/user/TagsCard';
import UsersCard from '../../redux/containers/user/UsersCard';

export default function AdminView(props) {
  const navigate = useNavigate();
  const { admin, user_id } = props.getRole;

  if (admin) {
    return (
      <>
        <Paper
          elevation={3}
          style={{
            width: '100%',
            height: '100%',
          }}>
          <Grid container xs={12}>
            <Grid item xs={3}>
              <Box
                display="flex"
                justifyContent="flex-start"
                marginLeft={'1em'}
                marginTop={'1em'}>
                <Button
                  variant="outlined"
                  onClick={() => navigate('/projects')}
                  startIcon={<ArrowBackIcon />}
                  size="small">
                  Go back
                </Button>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="h5" align="center" marginTop={2}>
                Admin dashboard
              </Typography>
            </Grid>
          </Grid>
          <Box margin={'1em'}>
            <Divider>Users</Divider>
          </Box>
          <Box margin={'3em'}>
            <Paper elevation={1}>
              <UsersCard user_id={user_id} admin />
            </Paper>
          </Box>
          <Box margin={'1em'}>
            <Divider>Tags</Divider>
          </Box>
          <Box margin={'3em'}>
            <Paper elevation={1}>
              <TagsCard user_id={user_id} />
            </Paper>
          </Box>
        </Paper>
      </>
    );
  } else {
    return <div></div>;
  }
}
